namespace appn.views.provider.verifysendgriddomain {
    export function init(): void {
        $('.dnsrecord-link-copy-btn').on('click', function(e) {
            e.preventDefault();
            let textToCopy = $(this);
            textToCopy.select();
            navigator.clipboard.writeText(textToCopy.val() as string);
        });
    }
}
